export const TASK_UNIT_TYPES = [
  {
    title: 'Отметка о прочтении',
    value: 1,
  },
  // {
  //   title: 'Короткий ответ',
  //   value: 2,
  // },
  {
    title: 'Текстовый ответ',
    value: 3,
  },
  {
    title: 'Ссылка',
    value: 4,
  },
  {
    title: 'Файл',
    value: 5,
  },
  {
    title: 'Исходный код',
    value: 6,
  },
  {
    title: 'Выбор одного ответа из предложенных',
    value: 10,
  },
  {
    title: 'Выбор нескольких ответов из предложенных',
    value: 20,
  },
];

export const TASK_UNIT_AUTOTEST_TYPES = [
  {
    title: 'Выбор одного ответа из предложенных',
    value: 10,
  },
  {
    title: 'Выбор нескольких ответов из предложенных',
    value: 20,
  },
];

export const TASK_UNIT_TYPE_NAMES = {
  readingMark: 1,
  shortAnswer: 2,
  textAnswer: 3,
  link: 4,
  file: 5,
  code: 6,
  choiceOneOption: 10,
  choiceSeveralOptions: 20,
};

export default { TASK_UNIT_TYPES, TASK_UNIT_TYPE_NAMES };
